import {
  sideBar
} from './helpers'
window.$ = window.jQuery = require('jquery');
$(document).ready(function() {
  sideBar().init()
})
